import { createFileRoute, redirect } from '@tanstack/react-router'
import { getPreferredLang } from '@/hooks/useLang'

export const Route = createFileRoute('/')({
  beforeLoad: async () => {
    throw redirect({ to: '/$lang', params: { lang: await getPreferredLang() }, replace: true })
  },
})
